// TODO using timeout
const queriesToRun = (queries, cache, useCache) =>
  useCache ? queries.filter(query => !cache[query]) : queries

export default queriesToRun
